import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
  name: 'gameStatusMapper'
})
export class GameStatusMapperPipe implements PipeTransform {
  transform(value: any, limit: string) {
    if (value != null && value.toUpperCase() === 'PENDING') {
      return 'Waiting for more numbers';
    }
    if (value != null && value.toUpperCase() === 'CONFIRMED') {
      return 'Min players reached, pitched booked.';
    }
    if (value != null && value.toUpperCase() === 'CANCELLED') {
      return 'Not enough numbers';
    }
    return value;
  }
}
